// Application version configuration.
// Auto-bumped (minor) by .github/workflows/deploy-stage.yml on every push to
// staging; production deploys mirror this value and never bump
// (see .github/workflows/deploy-prod.yml). To cut a hand-picked major/minor
// release, edit APP_VERSION directly — the next staging deploy minor-bumps from there.
export const APP_VERSION = '1.770.0';

export const APP_NAME = 'Lab CRM';

// Build-time metadata injected by vite.config.ts.
// These globals are replaced with string literals at compile time,
// so the values are frozen to the exact moment the bundle was built.
export const VERSION_CONFIG = {
  appName: APP_NAME,
  version: APP_VERSION,
  commitHash: typeof __COMMIT_HASH__ !== 'undefined' ? __COMMIT_HASH__ : 'dev',
  buildDate: typeof __BUILD_TIMESTAMP__ !== 'undefined' ? __BUILD_TIMESTAMP__ : 'local',
};

export default VERSION_CONFIG;
